import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TicketService } from '../../../../../../common/services/Ticket.service';
import { ContactService } from '../../../../../../common/services/Contact.service';
import { UserService } from '../../../../../../common/services/User.service';
import { SearchService } from '../../../../../../common/services/Search.service';
import { AgentModalType } from '../../../../../../components/modals/agent-modal/agent-modal.const';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { Observable } from 'rxjs';
import { TicketsConst } from './tickets.const';
import { MergeModalType } from '../../../../../../components/modals/merge-modal/merge-modal.const';
import { FieldService } from 'app/common/services/Field.service';
import { ServiceService } from 'app/common/services/Service.service';
import { PriorityService } from 'app/common/services/Priority.service';
import { TicketTypeService } from 'app/common/services/TicketType.service';
import { CommonSettingsService } from '../../../../../../common/share-data/common.setting.service';
import { CommonService } from '../../../../../../common/services/Common.service';
import { SharedUserService } from '../../../../../../common/share-data/user.service';

@Component({
  selector: 'detail-user-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css', '../../../../../../../css/fuck.css', '../../../search/search.css'],
  providers: [
    TicketService,
    ContactService,
    UserService,
    SearchService,
    FieldService,
    ServiceService,
    PriorityService,
    TicketTypeService,
  ],
})
export class TicketContactComponent extends BaseListComponent {
  @ViewChild('agentTemplate') agentTemplate: ElementRef;
  @ViewChild('statusTemplate') statusTemplate: ElementRef;
  @ViewChild('mergeTemplate') mergeTemplate: ElementRef;

  @Input() target_user: any = {};
  @Output() onOpenTicket: EventEmitter<any> = new EventEmitter();
  @Output() newTicket: EventEmitter<any> = new EventEmitter();

  public lstAgents: any = [];
  public allStatus: any = [];
  public allAgents: any = [];
  public allSources = [
    { id: '', text: 'Nguồn khởi tạo' },
    { id: 'CALL_OUTBOUND', text: 'Gọi điện ra' },
    { id: 'CALL_INBOUND', text: 'Khách gọi điện' },
    { id: 'chat', text: 'Tin nhắn web' },
    { id: 'hand', text: 'Thêm mới' },
    { id: 'zalo', text: 'Zalo' },
    { id: 'email', text: 'Email' },
    { id: 'facebook', text: 'Kênh Facebook' },
  ];
  public allSourceSearch = [
    { id: '1', text: 'Ticket yêu cầu' },
    { id: '2', text: 'Ticket được giao' },
    { id: '3', text: 'Ticket đã tiếp nhận ' },
  ];
  public modelFilter: any = {
    source_search: '1',
    status: '',
    source_detail: '',
    assign_agent_id: '',
  };
  public modalAgentType = AgentModalType.AGENT_TO_TRANSPORT;
  public modalMergeType = MergeModalType.Contact;
  public ticketFields: any = [];
  public allService: any = [];
  public serviceParentMax: any = [];
  public allPriority: any = [];
  public allType: any = [];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private ticketService: TicketService,
    private searchService: SearchService,
    private sharedCommonSettings: CommonSettingsService,
    private sharedUserService: SharedUserService,
    private commonService: CommonService
  ) {
    super(changeDetector, toastr, modalService);
  }

  // tslint:disable-next-line:use-life-cycle-interface
  async ngOnInit() {
    await this.loadTicketFields();
    await this.getServices();
    await this.getAllAgent();
    await this.getStatus();
    this.allPriority = await this.sharedCommonSettings.getAllPriority();
    this.allType = await this.sharedCommonSettings.getAllType();
    // @ts-ignore
    const { detail_user_table_columns } = (await this.sharedCommonSettings.getUserConfig()) || {};
    const displayColumns = TicketsConst.displayColumns(this.ticketFields, this.serviceParentMax);
    if (detail_user_table_columns) {
      const saveDisplayColumns = JSON.parse(detail_user_table_columns);
      this.displayColumns = displayColumns.map(d => {
        try {
          const sD = saveDisplayColumns.find(sd => d.field === sd.field);
          if (sD) {
            d.display = sD.display;
          }
          return d;
        } catch (e) {
          return d;
        }
      });
    } else {
      this.displayColumns = displayColumns;
      await this.commonService
        .settingUserConfig({
          user_id: this.user._id,
          detail_user_table_columns: JSON.stringify(this.displayColumns),
        })
        .toPromise();
    }
    await this.loadData();
  }

  async getServices() {
    this.allService = await this.sharedCommonSettings.getAllService();
    const countMax = this.countLevels(this.allService);
    for (let i = 0; i < countMax; i++) {
      this.serviceParentMax.push({
        title: 'Nhóm dịch vụ cấp ' + (i + 1),
        key: i === 0 ? 'service_id' : 'service_id' + i,
        field: i === 0 ? 'service_id' : 'service_id' + i,
      });
    }
  }

  countLevels(data) {
    let maxLevel = 0;
    const findLevel = (item, currentLevel) => {
      const parent = data.find(d => d.id === item.parent_id);
      if (parent) {
        return findLevel(parent, currentLevel + 1);
      }
      return currentLevel;
    };

    data.forEach(item => {
      const level = findLevel(item, 1);
      if (level > maxLevel) {
        maxLevel = level;
      }
    });

    return maxLevel;
  }

  async loadTicketFields() {
    const res = await this.sharedCommonSettings.getAllTicketFields();
    res.forEach(e => {
      this.ticketFields.push({
        key: e.key,
        title: e.title,
        type: e.type,
      });
    });
  }
  async getStatus() {
    const res = await this.sharedCommonSettings.getAllStatus();
    const statusList = [];
    res.forEach((c: any) => {
      statusList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allStatus = statusList;
  }

  async getAllAgent() {
    const res = await this.sharedUserService.getAllUsers();
    const agentList = [];
    res.forEach((c: any) => {
      agentList.push({
        text: c.name,
        id: c._id,
      });
    });
    this.allAgents = [{ id: '', text: 'Chuyên viên' }, ...agentList];
  }

  async loadData(request: any = {}, sort?: any) {
    const params = {
      source: 'all',
      limit: this.page_size,
      offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
      sort_by: 'updated_at:desc',
    };
    const must: any = [];
    if (this.modelFilter.source_search) {
      switch (this.modelFilter.source_search) {
        case '2':
          must.push({ term: { assign_agent_id: this.target_user._id } });
          break;
        case '3':
          must.push({ term: { receiver_id: this.target_user._id } });
          break;
        default:
          must.push({ term: { requester_id: this.target_user._id } });
          break;
      }
    }

    if (this.modelFilter.status) {
      must.push({ term: { status: this.modelFilter.status } });
    }
    if (this.modelFilter.source_detail) {
      must.push({ match: { source_detail: this.modelFilter.source_detail } });
    }
    if (this.modelFilter.assign_agent_id) {
      must.push({
        match: { assign_agent_id: this.modelFilter.assign_agent_id },
      });
    }
    const condition: any = {
      must: [
        {
          bool: {
            must: must,
          },
        },
      ],
    };
    const body = {
      condition: JSON.stringify(condition),
      active_fields: ['assign_agent_id', 'requester_id'],
      type: 'ticket',
      label: 'and',
      sub_label: 'and',
      keyword: '',
      force_search: 'customer',
      limit: this.page_size,
      offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
    };

    this.searchService.list(params, body).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.data = res.data.res.list;
        this.data = this.data.map(e => {
          e.display_follow_users = TicketsConst.displayUsersColumns(e.follow_users, this.lstAgents);
          e.display_cc_users = TicketsConst.displayUsersColumns(e.cc_users, this.lstAgents);
          e.display_code = TicketsConst.displayCodeColumns(e);
          e.display_requester = TicketsConst.displayRequesterColumns(e.request, this.user);
          e.display_subject = TicketsConst.displaySubjectColumns(e, this.user);
          e.display_assignee = TicketsConst.displayAssigneeColumns(e, this.lstAgents);
          e.display_source = TicketsConst.displaySourceColumns(e);
          e.display_status = TicketsConst.displayStatusColumns(e);
          e.display_created_at = TicketsConst.displayTimeColumns(e.created_at);
          e.display_updated_at = TicketsConst.displayTimeColumns(e.updated_at);
          e.display_priority = TicketsConst.displayPriorityColumns(e.priority_id, this.allPriority);
          e.display_type = TicketsConst.displayTypeColumns(e.type_id, this.allType);
          e.display_duedate = TicketsConst.displayTimeColumns(e.duedate);
          this.ticketFields.forEach(t => {
            e['display_' + t.key] = TicketsConst.displayFieldColumn(e, t);
          });
          if (e.service_id) {
            let serviceKeys = Object.keys(e).filter(key => key.startsWith('service_id'));
            serviceKeys.forEach((key, index) => {
              const keys = key.replace('service_id', 'display_service_id');
              e[keys] = TicketsConst.displayServiceColumns(e[key], this.allService);
            });
          }

          return e;
        });
        this.initPage(res.data.res.total);
      } else {
        this.data = [];
      }
    });
  }

  async changedOptionView(data) {
    this.displayColumns = data;
    await this.commonService
      .settingUserConfig({
        user_id: this.user._id,
        detail_user_table_columns: JSON.stringify(this.displayColumns),
      })
      .toPromise();
  }

  async changeFilter(key, $event) {
    let value = $event.target.value;
    if (value === '-1') {
      value = '';
    }
    this.modelFilter[key] = value;
    await this.loadData();
  }

  async changeSelect2Filter(key, $event) {
    let value = $event.value;
    if (value === '-1' || value === 'Chuyên viên') {
      value = '';
    }
    this.modelFilter[key] = value;
    await this.loadData();
  }

  async resetModelFilter() {
    this.modelFilter = {
      source_search: '1',
      status: '',
      source_detail: '',
      assign_agent_id: '',
    };
    await this.loadData();
  }

  async openTicket(ticket: any) {
    this.onOpenTicket.emit({ data: ticket });
  }

  async submitFastStatus(status) {
    const ids = this.lstChecked;
    this.ticketService.updateMany({ _id: { $in: ids } }, { status: status }).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Cập nhật trạng thái thành công!');
          this.lstChecked = [];
          this.closeModal();
          this.data = this.data.map(e => {
            if (ids.includes(e._id.toString())) {
              e.status = status;
              e.display_status = TicketsConst.displayStatusColumns(e);
            }
            return e;
          });
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }
  async submitMergeTickets(id) {
    const ticketMerges = this.lstChecked.filter(check => check !== id);
    this.ticketService.merges({ ticket_id: id, merge_ticket_ids: ticketMerges }).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.throwSuccess('Hợp nhất ticket thành công!');
        this.closeModal();
        this.is_loading = true;
        setTimeout(() => {
          this.loadData();
          this.is_loading = false;
        }, 3000);
      } else {
        this.message = {
          class: 'alert dark alert-danger',
          content: res.message,
        };
      }
    });
  }

  async openAgentModal() {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.modelContent.title = 'Chuyển nhanh cho chuyên viên';
    this.openModal(this.agentTemplate, config);
  }

  async openMergeModal() {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.modelContent.title = 'Hợp nhất khách hàng';
    this.openModal(this.mergeTemplate, config);
  }

  async openStatusModal() {
    this.typeModal = 'changeStatus';
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Chuyển nhanh trạng thái',
      submit_title: 'Chuyển',
    };
    this.modelDisplay = [
      {
        key: 'fast_status',
        label: 'Trạng thái',
        type: FormFieldType.Select,
        value: this.model.fast_status,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
        options: {
          data: this.allStatus,
          select2Options: {
            placeholder: { id: '', text: 'Trạng thái' },
          },
        },
      },
    ];
    this.openModal(this.statusTemplate, config);
  }
  async openMergeTicket() {
    this.typeModal = 'mergeTicket';
    let ticketToMerge = this.data.filter(data => this.lstChecked.includes(data._id)) || [];
    const checkTicket = [];
    for (let i = 0; i < ticketToMerge.length; i++) {
      if (ticketToMerge[i].requester_id && !checkTicket.includes(ticketToMerge[i].requester_id)) {
        checkTicket.push(ticketToMerge[i].requester_id);
      }
    }
    if (checkTicket.length > 1) {
      return this.throwError('Bạn chỉ có thể hợp nhất những ticket có cùng một người yêu cầu!');
    }
    ticketToMerge = ticketToMerge.map(data => {
      return { id: data._id, text: `${data.subject} | mã: ${data.code}` };
    });
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Hợp nhất nhanh ticket',
      submit_title: 'Hợp nhất',
    };
    this.modelDisplay = [
      {
        key: 'main_id',
        label: 'Chọn ticket chính',
        type: FormFieldType.Select2,
        value: this.model.main_id,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
        options: {
          data: [{ id: '', text: 'Chọn' }, ...ticketToMerge],
          select2Options: {
            placeholder: { id: '', text: 'Ticket chính' },
          },
        },
      },
      {
        key: '_note',
        label: '',
        type: FormFieldType.Note,
        value: `<span class="mb-2 text-muted text-sm mt-1">Vui lòng chọn ticket chính trong danh sách ticket bạn đã chọn. Tất cả các ticket khác sẽ được hợp nhất vào ticket này!</span>`,
        width: 'full',
        order: 1,
      },
    ];
    this.openModal(this.statusTemplate, config);
  }

  async handleTransportAgent(item: any) {
    const payload = {
      assign_agent_id: item._id,
      assign_group_id: item.group_id || null,
    };
    const update_ids = this.lstChecked;
    this.ticketService.updateMany({ _id: { $in: update_ids } }, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Chuyển chuyên viên xử lý thành công!');
          this.lstChecked = [];
          this.closeModal();
          this.data = this.data.map(e => {
            if (update_ids.includes(e._id.toString())) {
              e.assign_agent_id = item._id;
              e.assign_group_id = item.group_id || null;
              e.display_assignee = TicketsConst.displayAssigneeColumns(e, this.lstAgents);
            }
            return e;
          });
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async handleSubmit(item?: any) {
    if (this.typeModal === 'changeStatus') {
      await this.submitFastStatus(item.fast_status);
    } else if (this.typeModal === 'mergeTicket') {
      await this.submitMergeTickets(item.main_id);
    }
  }
  async handleMergeAction() {
    await this.loadData();
  }
  async openNewTicket() {
    this.newTicket.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/user/tickets/tickets.component.ts